/* eslint-disable react/destructuring-assignment */
import React, { useState } from 'react';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import { InputAdornment, makeStyles } from '@material-ui/core';

const style = {
  // background: "#EFF0F7",
  boxSizing: 'border-box'
  // borderRadius: "8px",
};

const useStyles = makeStyles({
  root: {
    ' & .MuiInputBase-root': {
      background: 'white',
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px',
      padding: '14px 16px',
      width: '315px'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontFamily: 'Poppins',
      fontSize: '12px',
      left: '13px',
      textAlign: 'start',
      top: '-7px',
      width: 'fit-content',
      zIndex: '1'
    },
    '& .MuiInputLabel-shrink': {
      color: '#9BA0AD',
      transform: 'translate(-15px, -13px) scale(0.83)',
      transformOrigin: 'top left'
    }
  }
});

const CInput = (props) => {
  return <TextField style={{ ...style, ...props.xstyle }} {...props} />;
};

const COutlinedInput = (props) => {
  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel htmlFor="outlined-adornment-amount">{props.label}</InputLabel>
      <OutlinedInput style={{ ...style, ...props.xstyle }} {...props} />
    </FormControl>
  );
};

const CStandardInput = (props) => {
  return (
    <FormControl classes={props.formclasses} fullWidth={props.width === 'true'}>
      <InputLabel htmlFor={props.htmlFor}>{props.label}</InputLabel>
      <Input
        autoComplete="off"
        endAdornment={props.adornment}
        style={{ ...style, ...props.xstyle }}
        {...props}
      />
    </FormControl>
  );
};

const CStandardTextfield = (props) => {
  const [rows, setRows] = useState(props.rows || 1);
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setRows(rows + 1);
    }
  };
  return (
    <FormControl classes={props.formclasses} fullWidth={props.width === 'true'}>
      <InputLabel htmlFor={props.htmlFor}>{props.label}</InputLabel>
      <TextField
        autoComplete="off"
        endAdornment={props.adornment}
        InputProps={{
          disableUnderline: true,
          endAdornment: <InputAdornment position="end">{props.adornment}</InputAdornment>
        }}
        multiline
        onKeyPress={handleKeyPress}
        rows={rows}
        rowsMax={5}
        style={{ ...style, ...props.xstyle }}
        {...props}
      />
    </FormControl>
  );
};

const CStandardInputRefactored = (props) => {
  const classes = useStyles();
  return (
    <FormControl classes={{ root: classes.root }} fullWidth={props.width === 'true'}>
      <InputLabel htmlFor={props.htmlFor}>{props.label}</InputLabel>
      <Input
        autoComplete="off"
        endAdornment={props.adornment}
        style={{ ...style, ...props.xstyle }}
        {...props}
      />
    </FormControl>
  );
};

export { CInput, COutlinedInput, CStandardInput, CStandardInputRefactored, CStandardTextfield };
